import { toast } from 'react-toastify';

import type { ICommonError, IErrorDetails } from '@modules/types';

import i18n from 'i18next';

interface IBaseQueryCreatorErrorArguments {
  statusCode: string;
  errorData: ICommonError['data'];
}

interface ICatchCommonErrorArguments {
  errorData: IErrorDetails;
}

type ShowErrorToastArguments =
  | (ICatchCommonErrorArguments & { target: 'catchCommonError' })
  | (IBaseQueryCreatorErrorArguments & { target: 'baseQueryCreator' });

export const showErrorToast = (arguments_: ShowErrorToastArguments) => {
  const { target } = arguments_;
  const errorData = arguments_.errorData as ICommonError['data'];
  const title = errorData?.title;

  const fallbackMessage =
    target === 'baseQueryCreator'
      ? i18n.t(
          title ??
            errorData?.error ??
            errorData?.detail ??
            'common.toast.error.unknown'
        )
      : i18n.t(title ?? 'common.toast.error.try.again');

  const translationKey = errorData?.translationKey;

  const hasValidTranslation =
    translationKey &&
    i18n.exists(translationKey, {
      ns: 'serverTranslation',
    });

  const invalidTranslationKey = hasValidTranslation
    ? ''
    : ` [${translationKey ?? ''}]`;

  const errorMessage = hasValidTranslation
    ? i18n.t(translationKey, {
        ...errorData?.placeholders,
        ns: 'serverTranslation',
      })
    : `${fallbackMessage}${invalidTranslationKey}`;

  const formattedMessage =
    target === 'catchCommonError'
      ? i18n.t('common.toast.error.process', { error: errorMessage })
      : `${arguments_.statusCode}: ${errorMessage}`;

  toast.error(formattedMessage, {
    style: { whiteSpace: 'pre-wrap' },
    toastId: translationKey ?? 'generic-error',
  });
};
